/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.resources.staff.list.controllers', [
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.factory.notice'
])

.controller('ResourcesStaffListController', ['$scope', '$uibModal', 'ApiService', 'NoticeFactory', function($scope, $uibModal, ApiService, NoticeFactory) {

    $scope.gridLink = '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ui-sref="application.resourcesInstances({ id: \'{{ row.entity.id }}\' })">{{row.getProperty(col.field)}}</a></div>';
    $scope.gridTemplateLink = '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ui-sref="application.resourcesDetail({ id: \'{{ row.entity.resourceTemplateId }}\' })">{{row.getProperty(col.field)}}</a></div>';

    $scope.resourcesStaffList = {

      model: {},
      selected: [],
      selectedItems: [],

      notice: {},

      init: function () {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Personnel Manager'
        });
        this.getUsers();
        this.notice = new NoticeFactory();
      },

      invite: function () {
        $scope.$emit('AppController::users::invite');
      },

      getUsers: function () {
        ApiService.resource.instances.filterList('Staff').then(this.success, this.error);
      },

      hasStaff: function() {
        return (this.model instanceof Array && this.model.length > 0);
      },

      hasSelected: function() {
        return (this.selected.length > 0);
      },

      success: function (response) {
        $scope.resourcesStaffList.model = response.data.payload;
        console.log($scope.resourcesStaffList.model);
        console.log($scope.resourcesStaffList.model.length);
      },

      error: function (response) {
      }

    };

    $scope.gridOptions = {
      paginate: false,
      enableRowSelection: true,
      multiselect: true,
      columnDefs: [
        {
          field: 'id',
          displayName: 'ID',
          visible: false
        },
        {
          field: 'name',
          displayName: 'Name',
          cellTemplate: $scope.gridLink
        },
        {
          field: 'resourceTemplateName',
          displayName: 'Resource Template',
          cellTemplate: $scope.gridTemplateLink
        }
      ]
    };

    $scope.resourcesStaffList.init();


}]);